"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillOfLadingShipmentType = exports.BillOfLadingFreightPieceType = exports.BillOfLadingFreightType = exports.BillOfLadingAccessorial = void 0;
var BillOfLadingAccessorial;
(function (BillOfLadingAccessorial) {
    BillOfLadingAccessorial["Alcohol"] = "alcohol";
    BillOfLadingAccessorial["Appointment"] = "appointment";
    BillOfLadingAccessorial["CrossDock"] = "crossDock";
    BillOfLadingAccessorial["HazardousMaterials"] = "hazmat";
    BillOfLadingAccessorial["FbaAppointment"] = "fbaAppointment";
    BillOfLadingAccessorial["HomeDelivery"] = "homeDelivery";
    BillOfLadingAccessorial["CFS"] = "cfs";
    BillOfLadingAccessorial["Inside"] = "inside";
    BillOfLadingAccessorial["Liftgate"] = "liftgate";
    BillOfLadingAccessorial["LimitedAccess"] = "limitedAccess";
    BillOfLadingAccessorial["LocalInsideDelivery"] = "localInsideDelivery";
    BillOfLadingAccessorial["ResidentialLocation"] = "residential";
    BillOfLadingAccessorial["SortOrSegregate"] = "sortSeg";
    BillOfLadingAccessorial["Tobacco"] = "tobacco";
    BillOfLadingAccessorial["Tradeshow"] = "tradeshow";
    BillOfLadingAccessorial["TwicRequired"] = "twicRequired";
})(BillOfLadingAccessorial = exports.BillOfLadingAccessorial || (exports.BillOfLadingAccessorial = {}));
var BillOfLadingFreightType;
(function (BillOfLadingFreightType) {
    BillOfLadingFreightType["Bag"] = "Bag";
    BillOfLadingFreightType["Bale"] = "Bale";
    BillOfLadingFreightType["Box"] = "Box";
    BillOfLadingFreightType["Bucket"] = "Bucket";
    BillOfLadingFreightType["Bundle"] = "Bundle";
    BillOfLadingFreightType["Can"] = "Can";
    BillOfLadingFreightType["Carton"] = "Carton";
    BillOfLadingFreightType["Case"] = "Case";
    BillOfLadingFreightType["Coil"] = "Coil";
    BillOfLadingFreightType["Crate"] = "Crate";
    BillOfLadingFreightType["Cylinder"] = "Cylinder";
    BillOfLadingFreightType["Drum"] = "Drum";
    BillOfLadingFreightType["Pail"] = "Pail";
    BillOfLadingFreightType["Pallet"] = "Pallet";
    BillOfLadingFreightType["Pieces"] = "Pieces";
    BillOfLadingFreightType["Reel"] = "Reel";
    BillOfLadingFreightType["Roll"] = "Roll";
    BillOfLadingFreightType["Skid"] = "Skid";
    BillOfLadingFreightType["Tote"] = "Tote";
    BillOfLadingFreightType["Tube"] = "Tube";
    /** @deprecated was never used */
    BillOfLadingFreightType["Container"] = "Container";
    /** @deprecated use pieces instead */
    BillOfLadingFreightType["LooseItem"] = "LooseItem";
})(BillOfLadingFreightType = exports.BillOfLadingFreightType || (exports.BillOfLadingFreightType = {}));
var BillOfLadingFreightPieceType;
(function (BillOfLadingFreightPieceType) {
    BillOfLadingFreightPieceType["Bag"] = "Bag";
    BillOfLadingFreightPieceType["Barrel"] = "Barrel";
    BillOfLadingFreightPieceType["Bolt"] = "Bolt";
    BillOfLadingFreightPieceType["Box"] = "Box";
    BillOfLadingFreightPieceType["Canister"] = "Canister";
    BillOfLadingFreightPieceType["Carton"] = "Carton";
    BillOfLadingFreightPieceType["Case"] = "Case";
    BillOfLadingFreightPieceType["Container"] = "Container";
    BillOfLadingFreightPieceType["Crate"] = "Crate";
    BillOfLadingFreightPieceType["Cylinder"] = "Cylinder";
    BillOfLadingFreightPieceType["Pieces"] = "Pieces";
    BillOfLadingFreightPieceType["Roll"] = "Roll";
    BillOfLadingFreightPieceType["Tube"] = "Tube";
})(BillOfLadingFreightPieceType = exports.BillOfLadingFreightPieceType || (exports.BillOfLadingFreightPieceType = {}));
var BillOfLadingShipmentType;
(function (BillOfLadingShipmentType) {
    BillOfLadingShipmentType["Direct"] = "Direct";
    BillOfLadingShipmentType["Integrated"] = "Integrated";
})(BillOfLadingShipmentType = exports.BillOfLadingShipmentType || (exports.BillOfLadingShipmentType = {}));
//# sourceMappingURL=billOfLading.js.map